import React from "react";
import { ICONS } from "assets/scripts/constants/SvgIcons";
/* tslint:disable:max-line-length */
export const CALLBACK = (<svg viewBox="230 230 740 740" preserveAspectRatio="xMidYMid meet" aria-hidden="true" focusable="false">
		<g>
			<path d={[
    "M781.4,418.5c-48.7-48.7-109.7-81.2-174.1-93.2c-12-2.2-22.8,7.4-22,19.5l0,0c0.6,8.5,6.9,15.4,15.2,17",
    "c57.1,10.7,111.3,39.6,154.6,83c43.4,43.4,72.3,97.6,83,154.6c1.6,8.3,8.5,14.6,17,15.2l0,0c12.1,0.8,21.8-10,19.5-22",
    "C862.6,528.3,830.1,467.2,781.4,418.5L781.4,418.5z"
].join("\n")}/>
			<path d={[
    "M590.7,422.4L590.7,422.4c0.6,7.9,6.1,14.5,13.7,16.7c36,10.1,70,30.2,98.2,58.4",
    "c28.2,28.2,48.3,62.2,58.4,98.2c2.1,7.6,8.7,13.1,16.6,13.7l0,0c12.8,0.9,22.6-11.2,19.2-23.6c-11.8-42.1-35.2-81.8-67.9-114.5",
    "c-32.7-32.7-72.4-56.1-114.5-67.9C602,399.8,589.8,409.5,590.7,422.4z"
].join("\n")}/>
			<path d={[
    "M596.4,503.7L596.4,503.7c0.5,6.7,4.5,12.6,10.6,15.5c15.4,7.4,30,17.8,43,30.8c13,13,23.3,27.6,30.8,43",
    "c2.9,6.1,8.8,10.1,15.5,10.6h0c14.1,1,24.2-13.6,18.1-26.4c-9.1-19-21.8-37.2-38.1-53.5c-16.3-16.3-34.5-29-53.5-38.1",
    "C610,479.5,595.4,489.6,596.4,503.7z"
].join("\n")}/>
			<path d={[
    "M461.5,738.5c127.2,127.2,284,176.6,360.3,100.3c10.3-10.3,18.4-22.2,24.5-35.3c3.4-7.3,4.6-15.5,3.3-23.5",
    "l-5.3-33.9c-2.5-15.8-14-28.6-29.4-32.8l-98.1-26.7c-14-3.8-29,0.2-39.3,10.5l-28,28c-8.7,8.7-22.5,10-32.6,2.9",
    "c-26.8-18.8-53.2-41-78.5-66.3C513,636.4,490.8,610,472,583.2c-7.1-10.1-5.8-23.9,2.9-32.6l28-28c10.3-10.3,14.3-25.3,10.5-39.3",
    "l-26.7-98.1c-4.2-15.4-17.1-26.9-32.8-29.4l-33.9-5.3c-8-1.3-16.2-0.1-23.5,3.3c-13.2,6.1-25.1,14.2-35.3,24.5",
    "C284.9,454.5,334.3,611.3,461.5,738.5z"
].join("\n")}/>
		</g>
	</svg>);
export const SCHEDULE = (<svg viewBox="140 110 470 470" preserveAspectRatio="xMidYMid meet" aria-hidden="true" focusable="false">
		<path d={[
    "M428.8,390.7c13.1-13.1,31.1-21.2,51.1-21.2s38,8.1,51.1,21.2c13.1,13.1,21.2,31.1,21.2,51.1s-8.1,38-21.2,51.1",
    "c-13.1,13.1-31.1,21.2-51.1,21.2s-38-8.1-51.1-21.2c-13.1-13.1-21.2-31.1-21.2-51.1S415.8,403.8,428.8,390.7 M479.9,346.1",
    "c-26.4,0-50.4,10.7-67.7,28c-17.3,17.3-28,41.3-28,67.7c0,26.4,10.7,50.4,28,67.7c17.3,17.3,41.3,28,67.7,28s50.4-10.7,67.7-28",
    "c17.3-17.3,28-41.3,28-67.7s-10.7-50.4-28-67.7C530.3,356.8,506.4,346.1,479.9,346.1z"
].join("\n")}/>
		<path d={[
    "M411.9,373.8c17.4-17.4,41.5-28.2,68.1-28.2c26.6,0,50.6,10.8,68.1,28.2c17.4,17.4,28.2,41.5,28.2,68.1",
    "c0,26.6-10.8,50.6-28.2,68.1c-17.4,17.4-41.5,28.2-68.1,28.2c-26.6,0-50.6-10.8-68.1-28.2c-17.4-17.4-28.2-41.5-28.2-68.1",
    "C383.7,415.3,394.5,391.2,411.9,373.8 M479.9,346.1c-26.4,0-50.4,10.7-67.7,28c-17.3,17.3-28,41.3-28,67.7c0,26.4,10.7,50.4,28,67.7",
    "c17.3,17.3,41.3,28,67.7,28s50.4-10.7,67.7-28c17.3-17.3,28-41.3,28-67.7s-10.7-50.4-28-67.7C530.3,356.8,506.4,346.1,479.9,346.1z"
].join("\n")}/>
		<path fill="none" d={[
    "M479.9,369.8c-39.8,0-72,32.2-72,72c0,39.8,32.2,72,72,72c39.8,0,72-32.2,72-72",
    "C551.9,402.1,519.7,369.8,479.9,369.8"
].join("\n")}/>
		<path d={[
    "M428.8,390.7c13.1-13.1,31.1-21.2,51.1-21.2s38,8.1,51.1,21.2c13.1,13.1,21.2,31.1,21.2,51.1s-8.1,38-21.2,51.1",
    "c-13.1,13.1-31.1,21.2-51.1,21.2s-38-8.1-51.1-21.2c-13.1-13.1-21.2-31.1-21.2-51.1S415.8,403.8,428.8,390.7 M479.9,370.1",
    "c-19.8,0-37.8,8-50.7,21c-13,13-21,30.9-21,50.7c0,19.8,8,37.8,21,50.7c13,13,30.9,21,50.7,21c19.8,0,37.8-8,50.7-21",
    "c13-13,21-30.9,21-50.7c0-19.8-8-37.8-21-50.7C517.7,378.1,499.7,370.1,479.9,370.1z"
].join("\n")}/>
		<path d={[
    "M205.1,227.8v211.2c0.4,21.9-2.8,20.7,24.5,20.3l135.6,0.1l0.2-22.6L228,436.1l0-159.9l252.3,0l0.1,45.7",
    "l22.6-0.4c-0.4-24.9-0.1-50.2-0.1-75.2c0.1-29.5-4-37.9-33.7-38.7c-1,9.7,0.3,17.1-4.5,24.6c-6.7,10.5-26.5,15.2-38-0.6",
    "c-5-6.8-3.9-14.2-4.3-23.9L285.7,208c-0.6,10,1.1,16.8-4.9,24.4c-3.7,4.6-9.4,9.6-18.7,9.4c-26-0.4-22.3-27.5-23.2-34.1",
    "C209.8,207.7,205,215.9,205.1,227.8"
].join("\n")}/>
		<polygon points="304.7,403.2 304.6,358.6 302.7,358.6 260,358.5 260.2,403 "/>
		<polygon points="304.6,334.5 304.5,290.6 259.5,290.7 259.6,334.4 "/>
		<polygon points="373.2,403.4 372.9,359.1 371.1,359.1 329,359.6 329.1,403.3 "/>
		<polygon points="397.3,334.4 441.7,334.4 441.5,328 441.5,297 441.6,290.6 397.3,290.7 "/>
		<polygon points="372.8,334.6 372.4,290.6 328.5,290.7 328.6,334.4 "/>
		<path d={[
    "M468.8,447.4l-13.3-35.8c-1.7-4.6,1.2-9.5,6.4-11c5.2-1.5,10.8,1,12.5,5.6l13.2,35.4l28.6,22.2",
    "c4,3.1,4.3,8.5,0.8,12c-3.5,3.5-9.6,3.8-13.6,0.7L471.8,452C470.2,450.8,469.2,449.2,468.8,447.4"
].join("\n")}/>
		<path d={[
    "M455.7,411.6l13.3,35.8l0,0c0.2,0.8,0.6,1.7,1.1,2.4c0.5,0.7,1.1,1.4,1.9,2l31.5,24.5c1.9,1.5,4.4,2.2,6.8,2",
    "c2.4-0.1,4.8-1.1,6.5-2.8c0.3-0.3,0.5-0.5,0.7-0.8c1.2-1.5,1.7-3.3,1.6-5.1c-0.1-1.8-0.9-3.5-2.3-4.9c-0.3-0.3-0.5-0.5-0.8-0.7",
    "l-28.6-22.2l-0.1-0.1l-13.2-35.4c-0.8-2.2-2.6-3.9-4.8-4.9c-2.2-1-4.9-1.2-7.4-0.5c-0.3,0.1-0.5,0.2-0.8,0.3",
    "c-2.2,0.8-3.9,2.3-4.9,4.1c-1,1.8-1.3,3.8-0.7,5.8C455.5,411.2,455.6,411.4,455.7,411.6 M468.5,447.5l-13.3-35.8",
    "c-0.1-0.2-0.1-0.4-0.2-0.6c-0.6-2.2-0.3-4.3,0.8-6.2c1.1-1.9,2.8-3.4,5.1-4.3c0.3-0.1,0.5-0.2,0.8-0.3c2.7-0.8,5.4-0.5,7.8,0.5",
    "c2.3,1,4.2,2.9,5.1,5.2l13.2,35.4l28.5,22.2c0.3,0.2,0.6,0.5,0.9,0.8c1.5,1.5,2.3,3.3,2.4,5.2c0.1,1.9-0.4,3.8-1.7,5.5",
    "c-0.2,0.3-0.5,0.6-0.8,0.9c-1.8,1.8-4.3,2.8-6.8,2.9c-2.5,0.1-5.1-0.6-7.1-2.2l-31.5-24.5c-0.8-0.6-1.5-1.3-2-2.1",
    "C469.1,449.3,468.7,448.4,468.5,447.5z"
].join("\n")}/>
		<path d={[
    "M261.9,163.7h2c8.2,0,14.9,6.7,14.9,14.9v38.8c0,8.2-6.7,14.9-14.9,14.9h-2c-8.2,0-14.9-6.7-14.9-14.9v-38.8",
    "C247,170.4,253.7,163.7,261.9,163.7"
].join("\n")}/>
		<path d={[
    "M445.9,164.4h2c8.2,0,14.9,6.7,14.9,14.9v38.8c0,8.2-6.7,14.9-14.9,14.9h-2c-8.2,0-14.9-6.7-14.9-14.9v-38.8",
    "C431,171.1,437.7,164.4,445.9,164.4"
].join("\n")}/>
	</svg>);
export const COURT = (<svg viewBox="105 92 302 302" preserveAspectRatio="xMidYMid meet" aria-hidden="true" focusable="false">
		{ICONS.COURT}
	</svg>);
export const MONEY = (<svg viewBox="200 200 600 600" preserveAspectRatio="xMidYMid meet" aria-hidden="true" focusable="false">
		{ICONS.MONEY}
	</svg>);
/* tslint:enable:max-line-length */ 



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/Account/Icons.tsx